import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Tab,
  Tabs,
  Grid,
  Typography,
  Button,
} from "@material-ui/core";
import PropTypes from "prop-types";
import { AfiliadoMenu } from "./Menus/AfiliadoMenu";
import { AdministrarMenu } from "./Menus/AdministrarMenu";
import {
  EMPADRONAMIENTO_MENU_GESTION,
  EMPADRONAMIENTO_SOLICITUDES_ESTADOS
} from "../../../utils/constants";
import { InformacionMenu } from "./Menus/InformacionMenu";
import { DocumentacionMenu } from "./Menus/DocumentacionMenu";
import { EmpadronamientoMedicamentosModalGestionar } from "../Ingreso/EmpadronamientoMedicamentosModalGestionar";
import { NotasMenuEmpadronamiento } from "./Menus/NotasMenuEmpadronamiento";
import moment from "moment";
import { getAlertasEmpadronamiento, sendMailAlerta } from "../../../actions/empadronamiento/Empadronamiento";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      name={index}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export const ModalGestionarSolicitud = (props) => {
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState(
    EMPADRONAMIENTO_MENU_GESTION.AFILIADO
  );

  const { solicitudSeleccionada = {}, alertas } = useSelector((state) => state.empadronamiento);

  const { open } = props;

  useEffect(() => {
    setSelectedTab(EMPADRONAMIENTO_MENU_GESTION.AFILIADO);
  }, [open, solicitudSeleccionada?.idSolicitud]);

  useEffect(() => {
    dispatch(getAlertasEmpadronamiento(solicitudSeleccionada.idSolicitud));
  }, [dispatch, solicitudSeleccionada])

  const SendMail = () => {
    dispatch(sendMailAlerta(solicitudSeleccionada.afiliado.id_afiliado))
  }

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      //   maxWidth="lg"
      open={open}
      onClose={props.closeModalHandler}
    >
      <DialogTitle>Resumen de la Solicitud N°{solicitudSeleccionada?.idSolicitud}</DialogTitle>
      {alertas.fechaAlerta && (
        <Grid style={{ display: 'flex', margin: '0 auto', alignItems: 'center', width: '100%' }}>
          <Typography align="right" style={{ marginRight: '1rem', width: "60%", fontSize: '0.80rem' }}>
            {`Este afiliado posee una alerta de aviso para el día ${moment(alertas.fechaAlerta).format("DD-MM-YYYY")}`}
          </Typography>
          <Button variant="contained" color="primary" style={{ width: '10%', fontSize: '0.70rem' }} onClick={() => SendMail()}>
            Enviar Mail
          </Button>
        </Grid>
      )}
      <DialogContent>
        <Tabs
          value={selectedTab}
          onChange={(event, newValue) => setSelectedTab(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab
            value={EMPADRONAMIENTO_MENU_GESTION.AFILIADO}
            label="Afiliado"
            {...a11yProps(EMPADRONAMIENTO_MENU_GESTION.AFILIADO)}
          />
          <Tab
            value={EMPADRONAMIENTO_MENU_GESTION.INFORMACION}
            label="Informacion"
            {...a11yProps(EMPADRONAMIENTO_MENU_GESTION.INFORMACION)}
          />
          <Tab
            value={EMPADRONAMIENTO_MENU_GESTION.DOCUMENTACION}
            label="Documentacion"
            {...a11yProps(EMPADRONAMIENTO_MENU_GESTION.DOCUMENTACION)}
          />
          {(EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_REVISION === solicitudSeleccionada.idEstadoSolicitud
            || EMPADRONAMIENTO_SOLICITUDES_ESTADOS.PENDIENTE_AUTORIZACION === solicitudSeleccionada.idEstadoSolicitud
            || EMPADRONAMIENTO_SOLICITUDES_ESTADOS.ACTIVA === solicitudSeleccionada.idEstadoSolicitud
            || EMPADRONAMIENTO_SOLICITUDES_ESTADOS.RECHAZADA === solicitudSeleccionada.idEstadoSolicitud) && (
              <Tab
                value={EMPADRONAMIENTO_MENU_GESTION.MEDICACION}
                label="Medicacion"
                {...a11yProps(EMPADRONAMIENTO_MENU_GESTION.MEDICACION)}
              />
            )}
          <Tab
            value={EMPADRONAMIENTO_MENU_GESTION.NOTAS}
            label="Notas"
            {...a11yProps(EMPADRONAMIENTO_MENU_GESTION.NOTAS)}
          />
          <Tab
            value={EMPADRONAMIENTO_MENU_GESTION.ADMINISTRAR}
            label="Administrar"
            {...a11yProps(EMPADRONAMIENTO_MENU_GESTION.ADMINISTRAR)}
          />
        </Tabs>
        <TabPanel
          value={selectedTab}
          index={EMPADRONAMIENTO_MENU_GESTION.AFILIADO}
        >
          <AfiliadoMenu afiliado={solicitudSeleccionada?.afiliado} />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={EMPADRONAMIENTO_MENU_GESTION.INFORMACION}
        >
          <InformacionMenu solicitud={solicitudSeleccionada} />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={EMPADRONAMIENTO_MENU_GESTION.DOCUMENTACION}
        >
          <DocumentacionMenu solicitud={solicitudSeleccionada} />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={EMPADRONAMIENTO_MENU_GESTION.NOTAS}
        >
          <NotasMenuEmpadronamiento />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={EMPADRONAMIENTO_MENU_GESTION.ADMINISTRAR}
        >
          <AdministrarMenu
            closeModalAuditar={props.closeModalHandler}
            postRetomarSolicitud={props.postRetomarSolicitud}
            postAutorizarSolicitud={props.postAutorizarSolicitud}
            postLiberarSolicitud={props.postLiberarSolicitud}
            setOpenModalGestionar={props.setOpenModalGestionar}
            fromGestion={true} />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={EMPADRONAMIENTO_MENU_GESTION.MEDICACION}
        >
          <EmpadronamientoMedicamentosModalGestionar />
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
};
